'use client';

import { useEffect } from 'react';

import {
  APP_DOWNLOAD_AUTO_REDIRECT_SESSION_KEY,
  type AppStoreTarget,
  getAppStoreTarget,
  getAppStoreUrls,
} from '@/utils/appDownload';

const hasAutoRedirected = () => {
  try {
    return (
      window.sessionStorage.getItem(APP_DOWNLOAD_AUTO_REDIRECT_SESSION_KEY) ===
      'true'
    );
  } catch {
    return false;
  }
};

const markAutoRedirected = () => {
  try {
    window.sessionStorage.setItem(
      APP_DOWNLOAD_AUTO_REDIRECT_SESSION_KEY,
      'true',
    );
  } catch {
    // Storage can be unavailable in restrictive browser modes.
  }
};

const moveToStore = (target: AppStoreTarget) => {
  const { fallbackUrl, schemeUrl } = getAppStoreUrls(target);

  window.location.replace(schemeUrl);

  window.setTimeout(() => {
    if (!document.hidden) {
      window.location.replace(fallbackUrl);
    }
  }, 700);
};

export const AppDownloadAutoRedirect = () => {
  useEffect(() => {
    const storeTarget = getAppStoreTarget();

    if (!storeTarget) return;
    if (hasAutoRedirected()) return;

    markAutoRedirected();
    moveToStore(storeTarget);
  }, []);

  return null;
};
